import { FlagsModule } from '@seddi/ui-feature-flags';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { downloadImage } from '../../actions/captureImage';
import type { TRootState } from '../../store/appStateTypes';
import { setViewerRef } from '../../store/appRefsSlice';
import { getScene } from '../../store/appSlice';

export const useAppViewer = () => {
  const dispatch = useDispatch();
  const resolution = useSelector((state: TRootState) => state.app.resolution);
  const sceneVersion = useSelector((state: TRootState) => state.app.sceneVersion);

  const scene = useMemo(() => {
    return getScene();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sceneVersion is intended to memoize the new scene
  }, [sceneVersion]);

  const viewerRef = useRef<any>(null);

  useEffect(() => {
    // communicate viewerRef through state
    dispatch(setViewerRef(viewerRef));
    // clear viewerRef state
    return () => {
      dispatch(setViewerRef(null));
    };
  }, [dispatch]);

  const config = useMemo(() => {
    const useStitchesDecals = FlagsModule.isEnabled('use_stitches_decals');
    return { useStitchesDecals };
  }, []);

  const handleDownloadImage = useCallback(() => {
    if (viewerRef.current) {
      downloadImage(viewerRef.current, 'image/webp');
    }
  }, []);

  return { config, handleDownloadImage, resolution, scene, viewerRef };
};
